import React from 'react';
import './WhyChooseSection.css';

export default function WhyChooseSection() {
  const features = [
    {
      id: 1,
      icon: "🌐",
      title: "Flexible Learning",
      description: "Study at your own pace from anywhere in India with our comprehensive distance learning programs."
    },
    {
      id: 2,
      icon: "🛡️",
      title: "UGC Recognized",
      description: "All programs are approved by UGC and NAAC accredited, ensuring quality education and valid degrees."
    },
    {
      id: 3,
      icon: "🎓",
      title: "Expert Faculty",
      description: "Learn from experienced professors with industry knowledge and academic excellence."
    },
    {
      id: 4,
      icon: "⚡",
      title: "Digital Resources",
      description: "Access e-books, recorded lectures, and digital study materials through our online portal."
    },
    {
      id: 5,
      icon: "📈",
      title: "Career Growth",
      description: "Programs designed to enhance your professional skills and career prospects."
    },
    {
      id: 6,
      icon: "⭐",
      title: "NAAC A++ Grade",
      description: "EDULEARNER holds NAAC A++ accreditation, reflecting our commitment to quality."
    }
  ];

  return (
    <section className="why-choose-section" id="why-choose">
      <div className="why-choose-container">
        
        {/* Section Header */}
        <div className="section-header">
          <span className="sub-title">WHY CHOOSE US</span>
          <h2 className="main-title">Why Choose CDOE, EDULEARNER?</h2>
        </div>

        {/* Features Grid Layout */}
        <div className="features-grid">
          {features.map((item) => (
            <div key={item.id} className="feature-card">
              <div className="feature-icon-box">
                <span className="feature-icon">{item.icon}</span>
              </div>
              <h3 className="feature-card-title">{item.title}</h3>
              <p className="feature-card-desc">{item.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}